<div *ngIf="(isLoading$ | async)"></div>

<div [ngStyle]="{'margin-top':marginTopValue - 2 + 'px'}" *ngIf="!(isLoading$ | async) && !initialLoading">
  <div *ngIf="createToolbarEntity">
    <cml-panel-buttons [buttons]="buttons"></cml-panel-buttons>
  </div>
  <div class="form-container">
    <form [formGroup]="form" class="form">
      <ng-template ngFor let-field [ngForOf]="fields">
        <mat-form-field *ngIf="field.type === 'string'">
          <mat-label>{{field.title}}</mat-label>
          <input matInput [placeholder]="field.placeholder?? ''" [formControlName]="field.name" (blur)="trimming(field.name,field.noTrimValue)">
          <mat-error>{{getErrorMessage(field.name)}}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="field.type === 'number'">
          <mat-label>{{field.title}}</mat-label>
          <input matInput type="number" [placeholder]="field.placeholder?? ''" [formControlName]="field.name" (blur)="trimming(field.name,field.noTrimValue)">
          <mat-error>{{getErrorMessage(field.name)}}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="field.type === 'password'">
          <mat-label>{{field.title}}</mat-label>
          <input [type]="hidePassword ? 'password' : 'text'" [placeholder]="field.placeholder?? ''" matInput [formControlName]="field.name">
          <mat-icon matSuffix  (click)="hidePassword = !hidePassword">
            <i [ngClass]="hidePassword==true ?'cml-fw cml-sm cml-eye' : 'cml-fw cml-sm cml-eye-slash' "></i>
          </mat-icon>
          <mat-error>{{getErrorMessage(field.name)}}</mat-error>
        </mat-form-field>


        <mat-form-field *ngIf="field.type === 'boolean'">
          <mat-label>{{field.title}}</mat-label>
          <mat-select matNativeControl [formControlName]="field.name">
            <mat-option *ngIf="!field.required" class="empty-option">nezadáno</mat-option>
            <mat-option [value]="true">Ano</mat-option>
            <mat-option [value]="false">Ne</mat-option>
          </mat-select>
          <mat-error>{{getErrorMessage(field.name)}}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="field.type === 'date'">
          <mat-label>{{field.title}}</mat-label>
          <input matInput [formControlName]="field.name" [placeholder]="field.placeholder?? ''" [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error>{{getErrorMessage(field.name)}}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="field.type === 'enum'">
          <mat-label>{{field.title}}</mat-label>
          <mat-select [formControlName]="field.name">
            <mat-option *ngFor="let el of field.enumList; let i = index" [value]="i">
              {{el}}
            </mat-option>
          </mat-select>
          <mat-error>{{getErrorMessage(field.name)}}</mat-error>
        </mat-form-field>

          <cml-autocomplete-control *ngIf="field.type === 'autocomplete' && field.observable" [formControl]="$any(form.controls[field.name])" [errorMessage]="getErrorMessage(field.name)" [field]="field" ngDefaultControl></cml-autocomplete-control>
          <cml-dropdown *ngIf="field.type === 'dropdown' && field.observable" [formControl]="$any(form.controls[field.name])" [field]="field" ngDefaultControl [errorMessage]="getErrorMessage(field.name)"></cml-dropdown>
      </ng-template>
    </form>
  </div>
</div>

<cml-extended-detail></cml-extended-detail>
